import React from 'react'
import PropTypes from 'prop-types'

const RepairIcon = () => {
    // console.log(disabled)
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="41"
            viewBox="0 0 40 41"
            fill="none"
        >
            <g clipPath="url(#clip0)">
                <path
                    d="M11.6663 26.6685C10.0247 26.6703 8.44006 26.0664 7.21608 24.9724C5.99211 23.8783 5.21483 22.3712 5.03315 20.7396C4.85148 19.1081 5.27819 17.4668 6.23153 16.1304C7.18487 14.7939 8.5978 13.8562 10.1996 13.4968C9.73617 11.3353 10.1503 9.07823 11.351 7.22208C12.5517 5.36594 14.4406 4.0628 16.6021 3.59934C18.7637 3.13587 21.0207 3.55005 22.8769 4.75075C24.733 5.95145 26.0362 7.84032 26.4996 10.0018H26.6663C28.7329 9.99976 30.7265 10.7656 32.2602 12.1508C33.7939 13.5359 34.7581 15.4416 34.9658 17.4977C35.1735 19.5538 34.6098 21.6137 33.3841 23.2776C32.1584 24.9415 30.3582 26.0906 28.333 26.5018M24.9996 21.6685L19.9996 16.6685M19.9996 16.6685L14.9996 21.6685M19.9996 16.6685V36.6685"
                    stroke="#8594A8"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0">
                    <rect
                        width="40"
                        height="40"
                        fill="white"
                        transform="translate(0 0.0449219)"
                    />
                </clipPath>
            </defs>
        </svg>
    )
}

RepairIcon.propTypes = {
    disabled: PropTypes.bool,
}
export default RepairIcon
